import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M18.5 21.6597C19.8807 21.6597 21 20.5404 21 19.1597C21 17.779 19.8807 16.6597 18.5 16.6597C17.1193 16.6597 16 17.779 16 19.1597C16 20.5404 17.1193 21.6597 18.5 21.6597Z",
      stroke: "#955F3A",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M5.5 21.6597C6.88071 21.6597 8 20.5404 8 19.1597C8 17.779 6.88071 16.6597 5.5 16.6597C4.11929 16.6597 3 17.779 3 19.1597C3 20.5404 4.11929 21.6597 5.5 21.6597Z",
      stroke: "#955F3A",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 8.65967H20L23 11.6597V16.6597H16V8.65967Z",
      stroke: "#955F3A",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M16 3.65967H1V16.6597H16V3.65967Z",
      stroke: "#955F3A",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }